module.exports = __webpack_public_path__ + "static/media/zeus_vs_hades-gods_of_war.pragmaticplay.533ba54e.jpeg";